module.exports = __webpack_public_path__ + "static/media/sf-test-17.0996e105.mp3";